import { PageTitle } from "@/components/shared/title/page-title";
import { TundishHeatMetricsPage } from "./TundishHeatMetricsPage";
import { TundishHMProvider } from "./context/TundishHeatMetricContext";

const TundishHeatMetrics = () => {
	return (
		<>
			<PageTitle title="Tundish Heat Metrics" />
			<TundishHMProvider>
				<TundishHeatMetricsPage />
			</TundishHMProvider>
		</>
	);
};

export default TundishHeatMetrics;
